import { combineReducers } from 'redux'

import { reducer as adminUsers } from 'features/admin-users'
import { reducer as adminInvitations } from 'features/admin-invitations'
import { reducer as marketingEmails } from 'features/admin-registration-of-interest'

import { reducer as account } from 'features/account'
import { reducer as drivers } from 'features/drivers'
import { reducer as fleet } from 'features/fleet'
import { reducer as settings } from 'features/settings'

import { reducer as homepage } from 'features/homepage'
import notes from 'features/notes'

import { reducer as graphEndOfLease } from 'features/graph-end-of-lease'
import { reducer as graphKmTracking } from 'features/graph-km-tracking'
import { reducer as graphFleetComposition } from 'features/graph-fleet-composition'
import { reducer as graphMaturing } from 'features/graph-maturing'
import { reducer as graphOnOrder } from 'features/graph-on-order'
import { reducer as graphServiceExpiry } from 'features/graph-service-expiry'
import { reducer as graphWofExpiry } from 'features/graph-wof-expiry'
import { reducer as graphVehicleOnExtension } from 'features/graph-vehicle-on-extension'
import { reducer as graphVehicleEmissions } from 'features/graph-vehicle-emission'
import { reducer as graphFuelExceptionsTrends } from 'features/graph-fuel-exception'

import { reducer as reportEndOfLease } from 'features/report-end-of-lease'
import { reducer as reportExtensionRentals } from 'features/report-extension-rentals'
import { reducer as reportKmTracking } from 'features/report-km-tracking'
import { reducer as reportUpcomingMaturities } from 'features/report-upcoming-maturities'
import { reducer as reportVehicleServicing } from 'features/report-vehicle-servicing'
import { reducer as reportVehicleEmissions } from 'features/report-vehicle-emissions'
import { reducer as reportMissingOdometers } from 'features/report-missing-odometers'
import { reducer as reportVehiclesOnOrder } from 'features/report-vehicles-on-order'
import { reducer as reportWofRego } from 'features/report-wof-rego'
import { reducer as reportIncident } from 'features/report-incident-management'
import { reducer as reportDocuments } from 'features/report-documents'
import { reducer as reportExceptions } from 'features/report-exceptions'
import { reducer as exceptionNotes } from 'features/report-exceptions/exception-notes'
import { reducer as exceptionIssue } from 'features/report-exceptions/exception-issue'
import { reducer as exceptionHistory } from 'features/report-exceptions/exception-history'

import { reducer as fbtSubmissions } from 'features/fbt-submissions'
import { reducer as fbtSummary } from 'features/fbt-summary'

import { reducer as requestReliefVehicles } from 'features/request-relief-vehicles'
import { reducer as requestVehicleRelocations } from 'features/request-vehicle-relocations'
import { reducer as requestRucSummary } from 'features/request-ruc-summary'
import { reducer as requestContractVariations } from 'features/request-contract-variations/module'
import { reducer as requestVehicleSummary } from 'features/request-vehicle-summary'
import { reducer as featureToggles } from 'features/feature-toggle'
import { reducer as myDriveAppFeatureToggleSettings } from 'features/feature-toggle-settings'

export const makeRootReducer = () => {
  return combineReducers({
    adminUsers,
    adminInvitations,
    registrationOfInterest: marketingEmails,

    account,
    drivers,
    fleet,
    settings,
    featureToggles,
    myDriveAppFeatureToggleSettings,

    // graphs - for dashboard page
    graphEndOfLease,
    graphFleetComposition,
    graphKmTracking,
    graphMaturing,
    graphOnOrder,
    graphServiceExpiry,
    graphWofExpiry,
    graphVehicleOnExtension,
    graphVehicleEmissions,
    graphFuelExceptionsTrends,
    // homepage
    homepage,

    // reports
    reportEndOfLease,
    reportExtensionRentals,
    reportKmTracking,
    reportUpcomingMaturities,
    reportVehicleServicing,
    reportVehicleEmissions,
    reportMissingOdometers,
    reportVehiclesOnOrder,
    reportWofRego,
    exceptionNotes,
    exceptionIssue,
    exceptionHistory,
    reportIncident,
    reportDocuments,
    reportExceptions,

    // fbt
    fbtSubmissions,
    fbtSummary,

    // actions
    requestReliefVehicles,
    requestVehicleRelocations,
    requestRucSummary,
    requestContractVariations,
    requestVehicleSummary,
    notes,
  })
}

export default makeRootReducer
